// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '서울제약',
  targetSheetName: '6월 1일',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '표준코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No',
    '제품명',
    '성분명',
    '제품군',
    '자사/위탁',
    '표준코드',
    '급여/비급여',
    '약가',
    '수수료율',
    '비고',
  ],
});
